import React from 'react';
import useCurrentUser from '../../hooks/useCurrentUser';
import BaseWelcomeLetter from '../Application/BaseWelcomeLetter';

export const getHhaWelcomeLetterItems = (companyName) => [
    // 0: Header & Intro
    {
        id: 0,
        type: 'intro',
        company: companyName,
        title: "Home Health Aide (HHA) Welcome Letter",
        salutation: "Welcome",
        fields: [
            { name: "employeeName", placeholder: "Employee Name" }
        ],
        salutationSuffix: "to our company!",
        text: `We at ${companyName} welcome you to our office and we want you to know that we have established an open line of communication with all our employees. Please feel free to speak to us at any time. Kindly, note that:`
    },
    // 1: Hire Date
    {
        id: 1,
        type: 'field',
        label: "Your Official Date of Hire is:",
        name: "hireDate",
        inputType: "date",
        required: true
    },
    // 2: Supervisor
    {
        id: 2,
        type: 'field',
        label: "Your Immediate Supervisor is:",
        name: "supervisorName",
        placeholder: "Supervisor Name",
        required: true,
        disabled: true
    },
    // 2.5: First Patient Care Date
    {
        id: 2.5,
        type: 'field',
        label: "Your First Patient Care Date is:",
        name: "firstPatientCareDate",
        inputType: "date"
    },
    // 3: Pay Rates Header
    {
        id: 3,
        type: 'text_header',
        text: "Your Rates of Pay is:"
    },
    // 4: Pay Rate 1
    {
        id: 4,
        type: 'pay_rate',
        label: "Clinical Visit Rate",
        name: "payRate.regular_visit",
        unit: "per visit"
    },
    // 5: Pay Rate 2
    {
        id: 5,
        type: 'pay_rate',
        label: "Office Hourly Rate",
        name: "payRate.initial_assessment",
        unit: "per hour"
    },
    // 6: Introductory Period (CHHA specific wording)
    {
        id: 6,
        type: 'section',
        title: "I. INTRODUCTION AND PROBATION PERIOD",
        text: "All personnel will have an initial orientation and 90-day introductory period. During this time, your job performance will be evaluated. This introductory period may be extended if necessary.",
        bullets: [
            "Continued employment depends on satisfactory performance.",
            "Your supervisor will review your performance before the end of this period."
        ]
    },
    // 7: Reporting and Documentation
    {
        id: 7,
        type: 'section',
        title: "II. REPORTING AND DOCUMENTATION",
        text: "As a CHHA, timely documentation and communication are vital to patient care.",
        content_after: [
            {
                mode: 'list',
                items: [
                    "All visit notes must be submitted within 24 hours of the visit.",
                    "Notify the RN Case Manager immediately of any change in patient condition.",
                    "Ensure all tasks on the HHA plan of care are completed and documented."
                ]
            }
        ]
    },
    // 8: Professional Conduct
    {
        id: 8,
        type: 'section',
        title: "III. PROFESSIONAL CONDUCT",
        text: `You are expected to represent ${companyName} with professionalism and care.`,
        bullets: [
            "Wear your ID badge at all times during patient visits.",
            "Follow all HIPAA and patient confidentiality protocols.",
            "Adhere to the dress code policy for field staff."
        ]
    },
    // 9: Training & Compliance
    {
        id: 9,
        type: 'section',
        title: "IV. TRAINING AND COMPLIANCE",
        text: "Maintaining your certification and staying up to date with training is your responsibility.",
        content_after: [
            {
                mode: 'p',
                text: `${companyName} provides ongoing in-service training. You are required to complete at least 12 hours of in-service training annually.`
            }
        ]
    },
    // 10: Acknowledgement
    {
        id: 10,
        type: 'section_header',
        title: "V. ACKNOWLEDGEMENT AND SIGNATURES"
    },
    {
        id: 11,
        type: 'text_block',
        text: `By signing below, I acknowledge that I have received and understood the terms of my employment as a Certified Home Health Aide (CHHA) with ${companyName}`
    }
];

const HhaWelcomeLetter = ({ onClose }) => {
    const { companyName } = useCurrentUser();
    const safeCompanyName = companyName || "Infinite Home Health, Inc.";
    return (
        <BaseWelcomeLetter
            onClose={onClose}
            role="HHA"
            items={getHhaWelcomeLetterItems(safeCompanyName)}
            title="Welcome Letter And Agreement (HHA)"
            splitIndex={10}
        />
    );
};

export default HhaWelcomeLetter;